// Studio: dropdown for picking a git ref to diff against. Uses
// useRepoRefs to fetch branches and tags from the workspace-scoped
// /api/ws/:slug/r/:repo/refs endpoint via React Query.

import { useRepoRefs } from "./useRepoRefs";
import { useTranslation } from "../i18n";

export function RevPicker({
  slug,
  repo,
  value,
  onChange,
}: {
  readonly slug: string;
  readonly repo: string;
  readonly value: string;
  readonly onChange: (ref: string) => void;
}) {
  const { t } = useTranslation("diff");
  const { data, isPending, isError } = useRepoRefs({ slug, repo });

  const branches = data?.branches ?? [];
  const tags = data?.tags ?? [];

  return (
    <select
      className="rounded-lg border border-slate-700 bg-slate-800 px-2.5 py-1.5 text-sm text-slate-100 transition-colors focus:border-arch-500 focus:outline-none focus:ring-2 focus:ring-arch-500/25 disabled:opacity-50"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={isPending || isError}
    >
      {isPending && <option value="">{t("revPicker.loading")}</option>}
      {isError && <option value="">{t("revPicker.loadFailed")}</option>}
      {branches.length > 0 && (
        <optgroup label={t("revPicker.branches")}>
          {branches.map((b) => (
            <option key={b} value={b}>
              {b}
            </option>
          ))}
        </optgroup>
      )}
      {tags.length > 0 && (
        <optgroup label={t("revPicker.tags")}>
          {tags.map((tag) => (
            <option key={tag} value={tag}>
              {tag}
            </option>
          ))}
        </optgroup>
      )}
    </select>
  );
}
